import React from 'react';
import {Control, FieldValues} from 'react-hook-form';
import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import FormCheckbox from '../FormCheckbox';

interface Props {
  control: Control<FieldValues>;
}

const PendingDataFilter: React.FC<Props> = ({control}) => {
  const {t} = useTranslation();

  return (
    <Box sx={{mb: 2}}>
      <Typography variant="h4" sx={{mb: 2}}>
        {t('sessionFilter.dataStatus')}
      </Typography>
      <Box>
        <FormCheckbox
          control={control as unknown as Control<FieldValues>}
          name={`dataStatus.pending`}
          label={`${t('sessionFilter.hasPendingData')}`}
        />
        <FormCheckbox
          control={control as unknown as Control<FieldValues>}
          name={`dataStatus.processed`}
          label={`${t('sessionFilter.allProcessed')}`}
        />
      </Box>
    </Box>
  );
};

export default PendingDataFilter;
